export default "__VITE_ASSET__D$UxLodi__"